module.exports = __webpack_public_path__ + "assets/img/sdwan-module2-1.187925df.jpg";